import {Component, Input, Output, EventEmitter, AfterViewInit, OnDestroy} from '@angular/core';

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: [],
    standalone: false
})
export class FileUploadComponent implements AfterViewInit, OnDestroy {
  /**
   * The unique id for the fields
   */
  @Input() id: string;

  /**
   * textkey for the label
   */
  @Input() label: string;

  /**
   * should the button be disabled or not
   */
  @Input() disabled: boolean = false;

  /**
   * the accepted file formats.
   */
  @Input() accept: string = "image/*,application/pdf";

  /**
   * Eventhandler if a file is changed
   */
  @Output() fileChange = new EventEmitter<{id: string, file: HTMLInputElement}>();

  /**
   * The filename of the selected file.
   */
  filename: string;


  /**
   * @inheritDoc
   */
  ngAfterViewInit(): void {
    const label = document.querySelector(`label[for="${this.id}"]`);

    // set focus on input field if label is focussed, to ensure keydown event for upload
    if (label) {
      label.addEventListener('keydown', (event: KeyboardEvent) => {
        if (event.key === ' ' || event.key === 'Enter') {
          event.preventDefault();
          document.getElementById(this.id)?.click();
          return false;
        }
      });
    }
  }

  /**
   * Eventhandler if a file is changed
   * @param field
   */
  fileChanged(field: HTMLInputElement): void {
    this.filename = field.files && field.files.length > 0? field.files[0].name : null;

    // inform all listeners
    this.fileChange.emit({id: this.id, file: this.filename? field : null})
  }

  /**
   * When component is destroyed, reset the image
   */
  ngOnDestroy(): void {
    this.fileChange.emit({id: this.id, file: null})
  }

}
